module.exports = __webpack_public_path__ + "img/glasses_male_round.a3dda7a0.png";